import { AlertClassColour, ConfigSystemParams, msSize } from 'src/app/core/consts';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { CompletedModalFormComponent } from '../../_pop-ups/completed-modal-form/completed-modal-form.component';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { ValidatorService } from 'src/app/core/services/utelize/general/validator-service';
import { WarningModalFormComponent } from '../../_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-input-modal-form',
  templateUrl: './input-modal-form.component.html',
  styleUrls: ['./input-modal-form.component.scss']
})

export class InputModalFormComponent implements AfterViewInit, OnDestroy, OnInit {
  
  @Input() date0Caption                        : string  = "Date 0";
  @Input() date0EnforceNotFuture               : boolean = false;
  @Input() date0Show                           : boolean = false;
  @Input() date0Value                          : string   | undefined;
  @Input() fieldCaption                        : string   | undefined;
  @Input() formTitle                           : string   | undefined;
  @Input() input0EnforceEmailValidation        : boolean  | undefined;
  @Input() input0EnforceGreaterThan0           : boolean  | undefined;
  @Input() input0EnforceIntegerInput           : boolean  | undefined;
  @Input() input0EnforceMaxLengthValidation    : boolean = true;
  @Input() input0EnforceMultipleEmailValidation: boolean  | undefined;
  @Input() input0EnforceRequiredValidation     : boolean = true;
  @Input() input0ForbiddenId                   : number   | undefined;
  @Input() input0ForbiddenIdMessage            : string   | undefined;
  @Input() input0MaxLength                     : number   | undefined;
  @Input() input0Show                          : boolean = true;
  @Input() input0Value                         : string   | undefined;
  @Input() input0Values                        : {name : string,id : number}[] | undefined;
  @Input() showProgressInformation             : boolean  | undefined;

  @Output() thisFormSaved    : EventEmitter<string>                                                   =new EventEmitter<string>                                                   ();
  @Output() thisFormSavedExt : EventEmitter<{ input0: string | undefined, date0: string | undefined }>=new EventEmitter<{ input0: string | undefined, date0: string | undefined }>();
  @Output() thisFormCancelled: EventEmitter<void>                                                     =new EventEmitter<void>                                                     ();
  
  @ViewChild('completedModalForm', { static: false }) completedModalForm!: CompletedModalFormComponent;
  @ViewChild('thisModalForm',      { static: false }) thisModalForm!     : TemplateRef<void>;
  @ViewChild('warningModalForm',   { static: false }) warningModalForm!  : WarningModalFormComponent;

  get maxDateAsIsoDate(): string { return this.todayAsIsoDate(); }

  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }
                          
  private initialStatus    : string="Please complete the following details";
  private thisModalFormRef!: NgbModalRef;
  
  public alertColourOrderStatus: string=AlertClassColour.Grey;
  public alertColourProgress   : string=AlertClassColour.Grey;
  public curUser               : SystemUserDTO;
  public preventAutofill       : boolean=true;
  public progressInformation   : string=this.initialStatus;
  public submitButtonEnabled   : boolean=true;
  public thisForm!             : UntypedFormGroup;
  public thisFormSubmitted     : boolean=false;

  constructor(
    private authenticationService: AuthenticationService,
    private configSystemService  : ConfigSystemService,
    private exceptionsService    : ExceptionsService,
    private formBuilder          : UntypedFormBuilder,
    private lastPassKillerService: LastPassKillerService,
    private modalService         : NgbModal,
    private validatorService     : ValidatorService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {
      if (!this.formTitle) {
        this.formTitle="Form Title not set";
      }
      
      if (!this.fieldCaption) {
        this.fieldCaption="Field Caption not set";
      }
      
      if (!this.input0MaxLength) {
        this.input0MaxLength=100;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public resetMainVariables(): void {
    try {
      this.alertColourProgress=AlertClassColour.Grey;
      this.progressInformation=this.initialStatus;
      this.thisFormSubmitted  =false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openForm(): void {
    try {
      this.resetMainVariables();
      this.setUpForm();
      this.enableDisableControls(false);
      this.openModal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
      this.thisModalFormRef=this.modalService.open(this.thisModalForm, { backdrop: this.modalBackGround, 
                                                                         centered: true,
                                                                         keyboard: false,
                                                                         size    : msSize.Small });
    }
    catch(e) {
      this.thisFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region thisForm

  get formOfThis() {
    return this.thisForm.controls;
  }

  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.removeFormFields(this.thisForm);

      this.thisForm=this.formBuilder.group({ });
      
      this.addFormFields(this.thisForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.thisForm) {
        if (this.input0Show) {
          const validators=[];

          if (this.input0EnforceEmailValidation) {
            validators.push(this.validatorService.emailValidator.bind(this.validatorService));
          }

          if (this.input0EnforceGreaterThan0) {
            validators.push(this.validatorService.greaterThanZeroValidator.bind(this.validatorService));
          }

          if (this.input0EnforceMaxLengthValidation) {
            validators.push(Validators.maxLength(this.input0MaxLength!));
          }

          if (this.input0EnforceMultipleEmailValidation) {
            validators.push(this.validatorService.multipleEmailValidator.bind(this.validatorService));
          }

          if (this.input0EnforceRequiredValidation) {
            validators.push(Validators.required);
          }

          if (this.input0ForbiddenId !== undefined) {
            validators.push(this.validatorService.forbiddenIdValidator(this.input0ForbiddenId));
          }

          this.addFormControl(formGroup, "input0", this.input0Value, validators);
        }

        if (this.date0Show) {
          const date0Validators=this.date0EnforceNotFuture
                                ? [Validators.required, this.validatorService.dateMustNotBeFutureValidator.bind(this.validatorService)]
                                : [Validators.required, this.validatorService.dateMustBeFutureValidator.bind(this.validatorService)];
          const date0Initial   =this.date0EnforceNotFuture
                                ? this.date0Value
                                : this.date0Value ?? this.todayAsIsoDate();
                                
          this.addFormControl(formGroup, "date0", date0Initial, date0Validators);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private todayAsIsoDate(): string {
    try {
      const today: Date  =new Date();
      const yyyy : string=String(today.getFullYear()    );
      const mm   : string=String(today.getMonth   () + 1).padStart(2, "0");
      const dd   : string=String(today.getDate    ()    ).padStart(2, "0");

      return yyyy + "-" + mm + "-" + dd;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | number | string | undefined,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private populateFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.thisForm) {
        this.thisForm.controls["input0"].setValue(undefined);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private enableDisableControls(enabled: boolean) {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public thisFormSubmitAttempt() {
    try {
      this.thisFormSubmitted=true;

      if (this.thisForm.valid) {
          this.thisFormSubmit();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public thisFormSubmit() {
    try {
      if (this.date0Show) {
        this.thisFormSavedExt.emit({
          input0: this.input0Show ? this.thisForm.get("input0")?.value : undefined,
          date0 : this.thisForm.get("date0")?.value
        });
      }
      else {
        this.thisFormSaved.emit(this.thisForm.get("input0")?.value);
      }

      this.thisModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public thisFormCancel() {
    try {
      this.thisFormCancelled.emit();
      this.thisModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Process Complete

  private processComplete() {
    try {
      this.completedModalForm.openForm("Complete", "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
